import ProducerService from 'src/modules/producer/producerService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { i18n } from 'src/i18n';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PRODUCER_FORM';

const producerFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: producerFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ProducerService.find(id);
      }

      dispatch({
        type: producerFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: producerFormActions.INIT_ERROR,
      });

      navigateTo('/library/producer');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: producerFormActions.CREATE_STARTED,
      });

      await ProducerService.create(values);

      dispatch({
        type: producerFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.producer.create.success'));

      navigateTo('/library/producer');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: producerFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: producerFormActions.UPDATE_STARTED,
      });

      await ProducerService.update(id, values);

      dispatch({
        type: producerFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.producer.update.success'));

      navigateTo('/library/producer');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: producerFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default producerFormActions;
